import request from '@/utils/request'

/**
 * 获取配置
 * @param {*} data
 */
export const get_config = key => {
  return request({
    url: `/api/config/${key}`,
    method: 'get'
  })
}

// 获取字典内容
// export const get_dict_value_list = id => {
//   return request({
//     url: `/api/res/dict/value/list?resDictId=${id}`,
//     method: 'get'
//   })
// }

export const get_dict_value_list = data => {
  return request({
    url: `/api/res/dict/value/all`,
    method: 'post',
    data: data,
    isToken: true
  })
}
